module.exports = __webpack_public_path__ + "img/design-1.dd49b7b4.jpg";